import { OrderCostDisplayValueTag } from '../types/orders';
import { PalletteProps } from '../types/theme/pallette';

export const getOrderDisplayColor = (
  displayStatus: OrderCostDisplayValueTag, 
  theme: PalletteProps['theme']
): string => {
  switch (displayStatus) {
    case 'info':
      return theme.toastifyInfo;
    case 'success':
      return theme.toastifySuccess;
    case 'warning':
      return theme.toastifyWarning;
    case 'error':
      return theme.toastifyError;
    case true:
      return theme.successColor;
    case false:
      return theme.nonProductActiveColor;
    default:
      return theme.white;
  }
};
